import { useMemo } from "react";
import { isParameterApp } from "../../automationObjects/parameterApps";
import { LoadingView } from "../../components";
import { useGetObjectsChildren } from "../../hooks/useGetObjectsChildren";
import ParametersView from "./ParametersView";

const ParametersViewWrapper = (props: { parentId: string, resourceGroupId: string }) => {
    const { children, error, isLoading, isSuccess } = useGetObjectsChildren(props.resourceGroupId, props.parentId);
    const filterdItems = useMemo(() => {
        return children?.filter((a) => isParameterApp(a.schema)).sort((a,b) => a.schema.startsWith('AutomationApps.FunctionGroups') ? 1 : -1)
    }, [children])

    return (
        <LoadingView isLoading={isLoading} error={error} isSucess={isSuccess}>
            <ParametersView children={filterdItems}></ParametersView>
        </LoadingView>
    )

}

export default ParametersViewWrapper;